import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  loading: {
    position: 'relative',
    width: '100%',
    height: '100%'
  },

  noBilling: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '3rem',
    width: '100%',
    color: theme.palette.indicator.red,
    fontSize: theme.size.sm
  }
}))

export default useStyles
